<div *ngIf="(rl.remaining$ | async)! > 0" class="rate-limit-banner">
    Too many requests. Try again in <strong>{{ rl.remaining$ | async }}</strong>s.
</div>
<form
  class="d-flex align-items-center chat-box-form" 
  [formGroup]="searchForm" 
  (ngSubmit)="onSubmit()"
>
  <textarea
    #inputElement
    class="form-control chat-textarea"
    formControlName="query"
    [placeholder]="aiAssistantPlaceholder"
    aria-label="Chat input"
    rows="3"
    (keydown)="handleKeyDown($event)"
    (compositionstart)="handleCompositionStart()"
    (compositionend)="handleCompositionEnd()"
  ></textarea>
  
  <button 
    type="submit" 
    class="btn btn-primary chat-send-btn ms-3" 
    [disabled]="isLoading || isSearchButtonDisabled || isThrottled"
  >
    <span *ngIf="!isLoading">{{ searchButtonLabel }}</span>
    <div *ngIf="isLoading" class="spinner-border" role="status"></div>
  </button>
</form>
